export const Actiontypes = {
    PROFILE:"PROFILE",
    Contract:'Contract',
    MakeChannel:'MakeChannel'
  };
  